import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from "@mui/material";

import RestaurantIcon from "@mui/icons-material/Restaurant";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import { useDispatch, useSelector } from "react-redux";
import { getDashboardStats } from "../redux/slices/adminDashboardSlice";
const DashboardCard = ({
    title,
    value,
    icon,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        height: "100%",
      }}
    >
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Typography
              color="text.secondary"
              fontSize={14}
            >
              {title}
            </Typography>

            <Typography
              variant="h4"
              fontWeight={700}
              mt={1}
            >
              {value}
            </Typography>
          </Box>

          <Box
            sx={{
              background: "#f2f4f7",
              borderRadius: "50%",
              p: 1.5,
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

const AdminDashboard = () => {
  const dispatch = useDispatch();

  const {
    dashboardStats,
    loading,
  } = useSelector(
    (state) => state.adminDashboard
  );

  useEffect(() => {
    dispatch(getDashboardStats());
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        mt={10}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {/* Page Heading */}

      <Typography
        variant="h4"
        fontWeight={700}
        mb={1}
      >
        Dashboard
      </Typography>

      <Typography
        color="text.secondary"
        mb={4}
      >
        Restaurant Subscription Management
      </Typography>

      {/* Stats Cards */}

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title="Total Restaurants"
            value={
              dashboardStats?.totalRestaurants ||
              0
            }
            icon={
              <RestaurantIcon
                fontSize="large"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title="Active Restaurants"
            value={
              dashboardStats?.activeRestaurants ||
              0
            }
            icon={
              <CheckCircleIcon
                fontSize="large"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title="Pending Restaurants"
            value={
              dashboardStats?.pendingRestaurants ||
              0
            }
            icon={
              <PendingActionsIcon
                fontSize="large"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title="Expired Restaurants"
            value={
              dashboardStats?.expiredRestaurants ||
              0
            }
            icon={
              <CancelIcon
                fontSize="large"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title="Pending Payments"
            value={
              dashboardStats?.pendingPayments ||
              0
            }
            icon={
              <ReceiptLongIcon
                fontSize="large"
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title="Total Revenue"
            value={`₹ ${
              dashboardStats?.totalRevenue ||
              0
            }`}
            icon={
              <CurrencyRupeeIcon
                fontSize="large"
              />
            }
          />
        </Grid>
      </Grid>

      {/* Recent Activity */}

      <Card
        sx={{
          mt: 4,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <CardContent>
          <Typography
            variant="h6"
            fontWeight={600}
            mb={2}
          >
            Quick Overview
          </Typography>

          <Typography>
            Total Restaurants:{" "}
            {
              dashboardStats?.totalRestaurants
            }
          </Typography>

          <Typography>
            Active Subscriptions:{" "}
            {
              dashboardStats?.activeRestaurants
            }
          </Typography>

          <Typography>
            Pending Payments:{" "}
            {
              dashboardStats?.pendingPayments
            }
          </Typography>

          <Typography>
            Total Revenue: ₹
            {
              dashboardStats?.totalRevenue
            }
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminDashboard;